import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import {ViewerEndVo} from '../../common/shared/api/gateway/viewer/ViewerEndVo.interface';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';

/**
 * 뷰어 엔드 조회
 *
 * Origin: pageNicolasApi.getViewerEnd
 * API: GET /api/v1/viewer/end
 */
export async function getViewerEnd(
  {
    seriesId,
    productId,
    apiPath,
  }: {seriesId: number; productId: number; apiPath?: string},
  options?: FetcherOptions
): Promise<ApiResultVo & {result: ViewerEndVo}> {
  const response = await axiosBffFetch(
    `/api/gateway${apiPath || '/api/v2/viewer/end'}`,
    {
      method: 'GET',
      params: {
        series_id: seriesId,
        product_id: productId,
      },
    },
    options
  );
  return response.data;
}
